import _ from "lodash";

export const commonMutations = {
    __setData(state, data){
        for (const [objKey, objValue] of Object.entries(data)) {
            state[_.camelCase(objKey)] = objValue && typeof objValue === 'object' && !Array.isArray(objValue)?
                {...objValue}: objValue;
        }
    },
    __updateData(state, data){
        for (const [stateKey, stateValue] of Object.entries(data)) {
            for (const [objKey, objValue] of Object.entries(stateValue)) {
                state[stateKey][objKey] = objValue && typeof objValue === 'object' && !Array.isArray(objValue)?
                    {...objValue}: objValue;
            }
        }
    }
}
